// Without Null Filter
export default function WithoutNullFilter() {
	return function(items) {
		var filtered = [];
		for (var i = 0; i < items.length; i++) {
		  if (
			items[i] != null &&
			items[i].coords != null &&
			items[i].coords.length > 1
		  )
			filtered.push(items[i]);
		}
  
		return filtered;
	  };
}